export default {
  getInquiryList(state) {
    return state.inquiryList;
  },
  getInquiryStats(state) {
    return state.inquiryList.stats || { status_breakdown: [] };
  },
  getInquiry(state) {
    return state.inquiry;
  }
};
